export default "__VITE_ASSET__5_dG4FO6__"